
import React, { useState } from "react";
import matuscolor from "./image/matuscolor.png";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    offers: false,
    terms: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.terms) {
      alert("You must accept the terms and privacy policy.");
      return;
    }
    console.log("Submitted:", formData);
    alert("Form submitted!");
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full p-6 bg-white shadow-lg rounded-xl">
      <div className="flex justify-center mb-6">
        <img
          src={matuscolor}
          alt="Logo"
          className="max-w-full h-auto" 
          style={{ maxHeight: "120px" }} 
        />
      </div>
      <h2 className="text-2xl font-bold text-blue-900 text-center mb-6">
        Please provide your contact details
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
        name="firstName"
        placeholder="First Name Example"
        value={formData.firstName}
        onChange={handleChange}
        required
        className="w-full border border-gray-300 rounded-md p-2"
        />
        <input
        name="lastName"
        placeholder="Last Name Example"
        value={formData.lastName}
        onChange={handleChange}
        className="w-full border border-gray-300 rounded-md p-2"
        />
        <input
        name="email"
        type="email"
        placeholder="example@smsoptin.com"
        value={formData.email}
        onChange={handleChange}
        required
        className="w-full border border-gray-300 rounded-md p-2"
        />
        <input
        name="phone"
        type="tel"
        placeholder="+1234567891"
        value={formData.phone}
        onChange={handleChange}
        className="w-full border border-gray-300 rounded-md p-2"
        />

        <div className="flex items-center">
        <input
          type="checkbox"
          name="offers"
          checked={formData.offers}
          onChange={handleChange}
          className="mr-2"
        />
        <label className="text-blue-900">I would like to receive offers and news</label>
        </div>

        <div className="flex items-start gap-2">
        <input
          type="checkbox"
          name="terms"
          checked={formData.terms}
          onChange={handleChange}
          required
        />
        <label className="text-sm text-blue-900">
          I accept the{" "}
          <a
            href="https://s3.us-east-1.amazonaws.com/legal.matusintl.com/TERMS-AND-CONDITIONS.pdf"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>{" "}
          &{" "}
          <a
            href="https://s3.us-east-1.amazonaws.com/legal.matusintl.com/PRIVACY-POLICY.pdf"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </label>
        </div>

        <p className="text-xs text-gray-500 mt-2">
        By providing your phone number you agree to receive informational text messages from Matus International Inc. Consent is not a condition of purchase. Msg & data rates may apply. Reply HELP for help or STOP to cancel.
        </p>

        <div className="flex justify-between mt-6">
        <button
          type="button"
          className="text-gray-500 underline"
          onClick={() => alert("Skipped")}
        >
          SKIP
        </button>
        <button
          type="submit"
          className="bg-blue-900 text-white px-6 py-2 rounded-full hover:bg-blue-700 font-bold shadow-lg"
          style={{ backgroundColor: "#1e3a8a" }}
        >
          CONTINUE
        </button>
        </div>
      </form>
      </div>
    </div>
    );
};

export default ContactForm;
